class CarouselSliderAutoplay extends CarouselSlider {
  constructor() {
    super();
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = this.dataset.speed || 3000;
  }

  init() {
    super.init();
    if (this.autoplay) {
      this.startAutoplay();
    }
  }

  startAutoplay() {
    this.interval = setInterval(() => {
      let nextScroll;
      if (this.rtl) {
        nextScroll = this.slider.scrollLeft - this.slideSpan;
        if (nextScroll < 0) {
          nextScroll = this.slider.scrollWidth - this.grid.clientWidth;
        }
      } else {
        nextScroll = this.slider.scrollLeft + this.slideSpan;
        if (nextScroll >= this.slider.scrollWidth - this.grid.clientWidth) {
          nextScroll = 0;
        }
      }
      this.slider.scrollTo({ left: nextScroll, behavior: 'smooth' });
    }, this.speed);
  }
}

customElements.define('carousel-slider-autoplay', CarouselSliderAutoplay);
